import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  display: {},
  account: {}
}

export default {
  state,
  getters,
  mutations,
  actions
}
